'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _applicationinsightsJs = require('applicationinsights-js');

var _logLevelConstants = require('./../log-level-constants');

var _abstract_logger = require('./abstract_logger');

var _abstract_logger2 = _interopRequireDefault(_abstract_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function (_AbstractLogger) {
  _inherits(ApplicationInsightsLogger, _AbstractLogger);

  function ApplicationInsightsLogger(_ref) {
    var instrumentationKey = _ref.instrumentationKey,
        minimumLogLevel = _ref.minimumLogLevel;

    _classCallCheck(this, ApplicationInsightsLogger);

    var _this = _possibleConstructorReturn(this, (ApplicationInsightsLogger.__proto__ || Object.getPrototypeOf(ApplicationInsightsLogger)).call(this, minimumLogLevel));

    _applicationinsightsJs.AppInsights.downloadAndSetup({ instrumentationKey: instrumentationKey });
    _applicationinsightsJs.AppInsights.trackPageView();
    return _this;
  }

  _createClass(ApplicationInsightsLogger, [{
    key: 'trackPageView',
    value: function trackPageView(_ref2) {
      var page = _ref2.page,
          url = _ref2.url,
          _ref2$properties = _ref2.properties,
          properties = _ref2$properties === undefined ? {} : _ref2$properties;

      _applicationinsightsJs.AppInsights.trackPageView(page, url, properties);
    }
  }, {
    key: 'write',
    value: function write(_ref3) {
      var level = _ref3.level,
          message = _ref3.message,
          _ref3$properties = _ref3.properties,
          properties = _ref3$properties === undefined ? {} : _ref3$properties,
          _ref3$measurements = _ref3.measurements,
          measurements = _ref3$measurements === undefined ? {} : _ref3$measurements,
          _ref3$severityLevel = _ref3.severityLevel,
          severityLevel = _ref3$severityLevel === undefined ? 3 : _ref3$severityLevel,
          _ref3$handledAt = _ref3.handledAt,
          handledAt = _ref3$handledAt === undefined ? '' : _ref3$handledAt;

      try {
        /* eslint-disable no-console */
        if (level === _logLevelConstants.TRACE || level === _logLevelConstants.DEBUG || level === _logLevelConstants.INFO || level === _logLevelConstants.WARN) {
          _applicationinsightsJs.AppInsights.trackEvent(message, properties, measurements);
          return true;
        }
        if (level === _logLevelConstants.ERROR) {
          _applicationinsightsJs.AppInsights.trackException(message, handledAt, properties, measurements, severityLevel);
          return true;
        }
        _applicationinsightsJs.AppInsights.trackTrace(message, properties, severityLevel);
        return true;
      } catch (err) {
        console.error('could not log to console.', err);
        return false;
      }
      /* eslint-enable no-console */
    }
  }]);

  return ApplicationInsightsLogger;
}(_abstract_logger2.default);